<template>
	<div>
		<section class="content">
			<div class="row">
				<div class="col-md-12">
					<div class="box box-info">
						<!-- Input Addons -->
						<!--<div class="box-header with-border">-->
							<!--<h3 class="box-title">Device Information</h3>-->
						<!--</div>-->

						<div class="box-body">
              <ul class="detail-list">
                <li><i class="fa fa-id-card-o fa-cus-icon" aria-hidden="true"></i><span class="label-list">ID</span><span class="result-list">{{ device.id }}</span></li>
                <li><i class="fa fa-key fa-cus-icon" aria-hidden="true"></i><span class="label-list">IID</span><span class="result-list">{{ device.iid }}</span></li>
                <li><i class="fa fa-hourglass-half fa-cus-icon" aria-hidden="true"></i><span class="label-list">App Install (Updated)</span><span class="result-list">{{ device.updated }}</span></li>
                <li><i class="fa fa-hourglass fa-cus-icon" aria-hidden="true"></i><span class="label-list">App Login (Updated)</span><span class="result-list">{{ device.loginupdate }}</span></li>
                <li><i class="fa fa-cogs fa-cus-icon" aria-hidden="true"></i><span class="label-list">Manufacturer</span><span class="result-list">{{ device.manufacturer }}</span></li>
                <li><i class="fa fa-barcode fa-cus-icon" aria-hidden="true"></i><span class="label-list">Model</span><span class="result-list">{{ device.model }}</span></li>
                <li><i class="fa fa-exchange fa-cus-icon" aria-hidden="true"></i><span class="label-list">App Version</span><span class="result-list">{{ device.version }}</span></li>
                <li><i class="fa fa-exchange fa-cus-icon" aria-hidden="true"></i><span class="label-list">Debug Version</span><span class="result-list">{{ device.vdevice }}</span></li>
                <li><i class="fa fa-mobile-phone fa-cus-icon" aria-hidden="true"></i><span class="label-list">Google Play Services</span><span class="result-list">{{ device.gsmMajor }}{{ device.gsmMinor }}</span></li>
                <li><i class="fa fa-mobile-phone fa-cus-icon" aria-hidden="true"></i><span class="label-list">gsmMajor</span><span class="result-list">{{ device.gsmMajor }}</span></li>
                <li><i class="fa fa-mobile-phone fa-cus-icon" aria-hidden="true"></i><span class="label-list">gsmMinor</span><span class="result-list">{{ device.gsmMinor }}</span></li>
                <li><i class="fa fa-google fa-cus-icon" aria-hidden="true"></i><span class="label-list">PlayStore Major</span><span class="result-list">{{ device.playstoreMajor }}</span></li>
                <li><i class="fa fa-google fa-cus-icon" aria-hidden="true"></i><span class="label-list">PlayStore Minor</span><span class="result-list">{{ device.playstoreMinor }}</span></li>
                <li><i class="fa fa-location-arrow fa-cus-icon" aria-hidden="true"></i><span class="label-list">gapiAviablity</span><span class="result-list">{{ device.gapiAviablity }}</span></li>
                <li><i class="fa fa-facebook-square fa-cus-icon" aria-hidden="true"></i><span class="label-list">Facebook</span><span class="result-list">{{ device.facebook }}</span></li>
                <li><i class="fa fa-facebook-square fa-cus-icon" aria-hidden="true"></i><span class="label-list">Messenger</span><span class="result-list">{{ device.messenger }}</span></li>
                <li><i class="fa fa-address-card fa-cus-icon" aria-hidden="true"></i><span class="label-list">Name</span><span class="result-list">{{ device.name }}</span></li>
                <li><i class="fa fa-toggle-up fa-cus-icon" aria-hidden="true"></i><span class="label-list">Major</span><span class="result-list">{{ device.major }}</span></li>
                <li><i class="fa fa-toggle-down fa-cus-icon" aria-hidden="true"></i><span class="label-list">Minor</span><span class="result-list">{{ device.minor }}</span></li>
                <li><i class="fa fa-code-fork fa-cus-icon" aria-hidden="true"></i><span class="label-list">Patch</span><span class="result-list">{{ device.patch }}</span></li>
                <li><i class="fa fa-id-card-o fa-cus-icon" aria-hidden="true"></i><span class="label-list">SDK</span><span class="result-list">{{ device.sdk }}</span></li>
                <li><i class="fa fa-thermometer-2 fa-cus-icon" aria-hidden="true"></i><span class="label-list">TotalMem</span><span class="result-list">{{ device.totalMem }}</span></li>
                <li><i class="fa fa-th-list fa-cus-icon" aria-hidden="true"></i><span class="label-list">thresholdMem</span><span class="result-list">{{ device.thresholdMem }}</span></li>
              </ul>
						</div>
						<!-- /.box-body -->
					</div>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
export default {
  name: 'Settings',
  data : function () {
    return {
      device : {
        id: null,
        fbid: null,
        name: null,
        email: null,
        license: null,
        phone: null,
        taxi: null
      }
    }
  },
  computed: {
    store: function () {
      return this.$parent.$store
    }
  },
  mounted: function () {
     this.getdriver()
  },
  methods: {
    getdriver: function () {
      const state = this.store.state
      const iid = this.$route.params.iid
      const self = this

      var url = state.serverURI + 'api/a/device-list/'+ iid
			// GET /someUrl
		  this.$http.get(url).then((response) => {
		    // success callback
		    self.device = response.data
		  }, (response) => {
		    // error callback
		  });
    },
//    updateDriver: function (){
//      const state = this.store.state
//      const self = this
//      var url = state.serverURI + 'api/a/updateDevice/'
//      this.$http.post(url,self.driver).then((response) => {
//        if(response.status == 200){
//          self.$router.push({'name': 'Device List'});
//        }
//      }, (response) => {
//        // error callback
//      });
//    }
  }
}
</script>

<style>
.datetime-picker input {
  height: 4em !important;
}
.detail-list {
  padding: 0;
  margin: 0px;
  list-style: none;
}
.detail-list li {
  /*border: 1px solid red;*/
  border-bottom: 1px solid #d2d6de;
  padding: 8px 5px;
}
  .label-list {
    display: inline-block;
    margin-right: 10px;
    min-width: 155px;
  }
  .result-list {
    display: inline-block;
    font-weight: bold;
    color: #424242;
    padding: 5px 15px;
    background: #E0E0E0;
    border-radius: 3px;
  }
  .fa-cus-icon {
    margin-right: 6px;
    padding: 3px;
    width: 24px;
    color: #9E9E9E;
  }
</style>



// WEBPACK FOOTER //
// DeviceView.vue?6ca2697c